import { useCallback } from "react";
import { useAppSelector } from "redux/hooks";
import selectEntity from "module/staff/redux/selector/selectEntity";
import { EntityType } from "module/entity/types";
import { MyTrainingInterface } from "module/training/types";

interface Result {
  getReadableIdentifier: (id: string) => string;
}

const useMyTrainingReadableIdentifier = (): Result => {
  const selectEntityHelper = useAppSelector(selectEntity);
  const getReadableIdentifier = useCallback(
    (id: string): string => {
      const myEntity = selectEntityHelper({
        id,
        type: EntityType.training,
      }) as MyTrainingInterface;
      return myEntity.data.name;
    },
    [selectEntityHelper]
  );

  return {
    getReadableIdentifier,
  };
};

export default useMyTrainingReadableIdentifier;
